import { render, staticRenderFns } from "./OrganizationsList.vue?vue&type=template&id=30990e82&scoped=true"
import script from "./OrganizationsList.vue?vue&type=script&lang=js"
export * from "./OrganizationsList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsList.vue?vue&type=style&index=0&id=30990e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30990e82",
  null
  
)

export default component.exports